// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Palco verticale 9:16 per gli overlay OBS (dirette Instagram / YouTube). */
.ov-stage {
  position: fixed;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: stretch;
  gap: 10px;
  padding: var(--ov-safe-top) 20px var(--ov-safe-bottom);
  transform-origin: center center;
  overflow: hidden;
  pointer-events: none;
}
.ov-stage--top { justify-content: flex-start; }
.ov-stage--middle { justify-content: center; }
.ov-stage--bottom { justify-content: flex-end; }
`, "",{"version":3,"sources":["webpack://./src/components/obs/VerticalStage.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;EACT,sDAAsD;EACtD,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;AACA,iBAAiB,2BAA2B,EAAE;AAC9C,oBAAoB,uBAAuB,EAAE;AAC7C,oBAAoB,yBAAyB,EAAE","sourcesContent":["/* Palco verticale 9:16 per gli overlay OBS (dirette Instagram / YouTube). */\n.ov-stage {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: stretch;\n  gap: 10px;\n  padding: var(--ov-safe-top) 20px var(--ov-safe-bottom);\n  transform-origin: center center;\n  overflow: hidden;\n  pointer-events: none;\n}\n.ov-stage--top { justify-content: flex-start; }\n.ov-stage--middle { justify-content: center; }\n.ov-stage--bottom { justify-content: flex-end; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
